<script setup lang="ts">
  import { Text } from "@ui-kit";

  const { title } = defineProps<{ title?: string }>();
</script>

<template>
  <div class="section-block">
    <Text v-if="title" font="body-regular-14" color="secondary">{{ title }}</Text>
    <slot />
  </div>
</template>

<style scoped>
  .section-block {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
</style>
